import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { getUser } from "../../api/user.api";
import {
  Avatar,
  Box,
  Chip,
  Divider,
  Link,
  Stack,
  Typography,
  Grid,
} from "@mui/material";
import { getAwards } from "../../api/award.api";
import AwardCard from "../../components/cards/award.card";
import { getUserTournaments } from "../../api/tournament.api";
import { getUserEvents } from "../../api/event.api";
import moment from "moment";
import { getTeamsOfUser } from "../../api/team.api";
import TeamCard from "../../components/cards/team.card.js";
import { useNavigate } from "react-router-dom";
import CrisisAlertIcon from "@mui/icons-material/CrisisAlert";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import AttractionsIcon from "@mui/icons-material/Attractions";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

const ProfilePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const userId = useMemo(() => location.state.userId || {});
  const [user, setUser] = useState();
  const [awards, setAwards] = useState([]);
  const [tournaments, setTournaments] = useState([]);
  const [events, setEvents] = useState([]);
  const [teams, setTeams] = useState([]);

  useEffect(() => {
    setAwards([]);
    setUser({});
    getUser(userId)
      .then((response) => {
        setUser(response.data);
        getAwards(response.data.awards)
          .then((response) => setAwards(response.data))
          .catch((error) => console.log(error));
        getUserTournaments(response.data.id).then((response) =>
          setTournaments(response.data)
        );
        getUserEvents(response.data.id).then((response) =>
          setEvents(response.data)
        );
        getTeamsOfUser(userId).then((response) => setTeams(response.data));
      })
      .catch((error) => console.log(error));
  }, [userId]);

  const handleNavigateTournament = (tournament) => {
    navigate("/tournament", { state: { tournament } });
  };

  return (
    <div>
      {user && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "left",
          }}
        >
          <Box>
            <Avatar
              sx={{ width: 150, height: 150 }}
              alt={user.nickname}
              src={`/static/images/${user.avatarFileName ?? "default.jpg"}`}
            />
          </Box>
          <Box sx={{ ml: 4 }}>
            <Typography variant="h4">{user.nickname}</Typography>
            <Typography variant="h5">{user.fullName}</Typography>
          </Box>
        </Box>
      )}

      <Divider sx={{ mt: 3, mb: 3 }} />

      <Typography variant="h4" gutterBottom>
        Awards
      </Typography>
      <Grid container spacing={3}>
        {awards.length > 0 &&
          awards.map((award) => (
            <Grid key={award.id} xs={12} sm={6} md={4}>
              <AwardCard award={award} />
            </Grid>
          ))}
      </Grid>

      <Divider sx={{ mt: 3, mb: 3 }} />

      <Typography variant="h4" gutterBottom>
        Teams
      </Typography>

      {teams.length > 0 && (
        <Grid container spacing={1}>
          {teams.map((team) => (
            <Grid key={team.id} xs={12} sm={6} md={4}>
              <TeamCard team={team} big={true} />
            </Grid>
          ))}
        </Grid>
      )}

      <Divider sx={{ mt: 3, mb: 3 }} />

      <Typography variant="h4" gutterBottom>
        Progress
      </Typography>

      {events &&
        events.length > 0 &&
        events.map((event) => (
          <div key={event.id}>
            <Stack spacing={2} direction="row">
              <Typography variant="h5">{event.name}</Typography>
              <Typography
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "left",
                }}
              >
                {moment(event.start).format("DD.MM.YYYY")}
              </Typography>
            </Stack>
            <Stack spacing={1} direction="column">
              {tournaments &&
                tournaments.length > 0 &&
                tournaments
                  .filter((tournament) => tournament.eventId === event.id)
                  .map((tournament) => (
                    <div key={tournament.id}>
                      <Stack spacing={1} direction="row" alignItems="center">
                        <Link
                          onClick={() => handleNavigateTournament(tournament)}
                        >
                          <Typography variant="h6">
                            {tournament.name}
                          </Typography>
                        </Link>
                        <Typography variant="caption">
                          {tournament.game.name}
                        </Typography>
                        {tournament.game.category === "Shooter" && (
                          <CrisisAlertIcon sx={{ fontSize: 16, mr: 1 }} />
                        )}
                        {tournament.game.category === "Racing" && (
                          <DirectionsCarIcon sx={{ fontSize: 16, mr: 1 }} />
                        )}
                        {tournament.game.category === "Strategy" && (
                          <AccountBalanceIcon sx={{ fontSize: 16, mr: 1 }} />
                        )}
                        {tournament.game.category === "Other" && (
                          <AttractionsIcon sx={{ fontSize: 16, mr: 1 }} />
                        )}
                        <Typography variant="caption"> - </Typography>
                        <Chip
                          label={tournament.participantMode}
                          variant="outlined"
                          size="small"
                        />
                        <Chip
                          label={tournament.system}
                          variant="outlined"
                          size="small"
                        />
                      </Stack>
                    </div>
                  ))}
            </Stack>
            <Divider sx={{ mt: 1, mb: 1, width: 500 }} flexItem />
          </div>
        ))}
    </div>
  );
};

export default ProfilePage;
